module.exports = __webpack_public_path__ + "img/EMS_user_manual20_Layout.bd273c6a.png";